// extracted by mini-css-extract-plugin
export default {"container":"hb","header":"ib","logodesktop":"jb","logomobile":"kb","imgcontainer":"lb","slidercontainer":"mb","slick-slider":"nb","slick-initialized":"ob","sliderbox":"pb","headline":"qb","mainheadline":"rb","capitalize":"sb","desc":"tb","descitalic":"ub","desccenter":"vb","descborder":"wb","subdesc":"xb","welcomeslide":"yb","desccard":"zb","img":"Ab","button":"Bb","buttonskip":"Cb","customPosition":"Eb"};
    if(module.hot) {
      // 1713969930213
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  